import ModuleCodeContainer from "./ModuleCodeContainer"

export default ModuleCodeContainer
